import { Loader2 } from "lucide-react";

export function Loading({ label = "Loading" }) {
  return (
    <div className="flex-1 flex items-center justify-center py-24">
      <div className="flex items-center gap-2 text-slate-400 text-sm">
        <Loader2 className="h-4 w-4 animate-spin" /> {label}…
      </div>
    </div>
  );
}
